import React from "react";
import { BrowserRouter } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import { CartProvider } from "./contexts/CartContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { AgeGate } from "./components/AgeGate";
import { ScrollToTop } from "./components/ScrollToTop";
import { AppRoutes } from "./components/AppRoutes";
interface AppProps {
  showAgeGate?: boolean;
}
export function App({
  showAgeGate = true
}: AppProps) {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="31ayqs2ygxpzt">
      <BrowserRouter data-id="element-1" data-mp="31c1iue7j1yhb">
        <CartProvider data-id="element-2" data-mp="2wk0a329kipw1">
          <ScrollToTop data-id="element-3" data-mp="2wjgptewg3peu" />
          <div className="flex min-h-screen w-full flex-col bg-night text-white" data-id="element-4" data-mp="2wj8dpp85co4p">
            <Header data-id="element-5" data-mp="28tme50nv46w6" />
            <AppRoutes data-id="element-6" data-mp="28t4jg8gum0qd" />
            <Footer data-id="element-7" data-mp="28sb9kymlev40" />
          </div>
          <CartDrawer data-id="element-8" data-mp="23vunsb2v8su3" />
          <Toaster position="bottom-right" theme="dark" toastOptions={{
          style: {
            background: "#1B1B1B",
            border: "1px solid #272727",
            color: "#fff",
            borderRadius: "16px"
          },
          actionButtonStyle: {
            background: "#FFD400",
            color: "#0A0A0A",
            fontWeight: 700,
            borderRadius: "999px"
          }
        }} data-id="element-9" data-mp="23u9q4cl98ts0" />
          {showAgeGate && <AgeGate data-id="element-10" data-mp="67yhm9c7y5s" />}
        </CartProvider>
      </BrowserRouter>
    </MotionConfig>;
}